// import Router from "next/router";
import cookie from "react-cookies";

import { AppThunk } from "..";
import { sliceActions } from "./auth.slice";
import { ETypeOTP, UserAdmin } from "@/types";
import { accountActions } from "../account/account.action";
import { authApi } from "@/apis";
import toast from "react-hot-toast";
import { disconnect } from "@wagmi/core";
import { connectWalletRetx } from "@/lib/utils";

const authSuccess =
  (response: any): AppThunk =>
  async (dispatch) => {
    if (response?.accessToken) {
      cookie.save("access_token", response.accessToken, { path: "/" });
      cookie.save("refresh_token", response.refreshToken, { path: "/" });
      cookie.save("user_id", response.userId, { path: "/" });
    } else {
      dispatch(accountActions.setInfoAccount(new UserAdmin(response)));
    }

    dispatch(
      sliceActions.loginSuccess({
        loginFailed: null,
        loginSuccess: "Đăng nhập thành công",
      })
    );
  };

export const login =
  (otpToken: string, userId: string, password: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(sliceActions.loadingLogin());
      const response = await authApi.login(otpToken, { userId });
      dispatch(authSuccess(response));
      dispatch(authenticate(password));
      // Router.push("/");
    } catch (err) {
      dispatch(
        sliceActions.loginFailed({
          loginFailed: "Đăng nhập thất bại",
          loginSuccess: null,
        })
      );
    }
  };

export const authenticate =
  (password?: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(sliceActions.loadedAuth(true));
      const response = await authApi.authenticate();
      dispatch(authSuccess(response));

      console.log(response, response.isRetxWallet, password);
      if (response.isRetxWallet && password) {
        await connectWalletRetx({
          password,
        });
      }

      dispatch(sliceActions.setAuthLogin(true));
    } catch (err) {
      dispatch(sliceActions.setAuthLogin(false));
    } finally {
      dispatch(sliceActions.loadedAuth(false));
    }
  };

export const logoutUser = (): AppThunk => async (dispatch) => {
  authApi.logout().catch(() => {
    disconnect();
  });

  cookie.remove("access_token");
  cookie.remove("refresh_token");
  cookie.remove("user_id");
  dispatch(sliceActions.resetState());
  // Router.replace("/");
};

export const otpSend =
  (
    data: {
      type: ETypeOTP;
      userId: string;
      scenario: string;
    },
    onSuccess: () => void,
    onError?: (error: any) => void
  ): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(sliceActions.loadingOtpEmailSend());
      await authApi.sendOTP(data);
      dispatch(sliceActions.otpEmailSendFinished());
      onSuccess();
      toast.success("Đã gửi mã xác thử thành công");
    } catch (err) {
      dispatch(sliceActions.otpEmailSendFinished());
      onError(err);
    }
  };

export const otpVerify =
  (
    data: {
      type: ETypeOTP;
      userId: string;
      otpCode: string;
      scenario: string;
    },
    onSuccess: (otpToken: string) => void,
    onError?: () => void
  ): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(sliceActions.loadingOtpEmailVerify());
      const { otpToken } = await authApi.verifyOTP(data);
      onSuccess(otpToken);
      dispatch(sliceActions.otpEmailVerifySuccess(otpToken));
    } catch (err) {
      err?.message && toast.error(err?.message);
      dispatch(sliceActions.otpEmailVerifyFail(err?.errors || {}));
    }
  };

export const forgotPassword =
  (
    data: {
      email: string;
    },
    onSuccess: () => void,
    onError?: (error: any) => void
  ): AppThunk =>
  async (dispatch) => {
    try {
      await authApi.forgotPassword(data.email);

      toast.success(
        "Hệ thống đã gửi mail xác nhận về yêu cầu của bạn, Vui lòng kiểm tra hộp thư đến của bạn"
      );
      onSuccess();
    } catch (err) {
      if (err?.message) toast.error(err?.message);
      onError(err);
    }
  };

export const setMessage = sliceActions.setMessage;
export const preLoginSuccess = sliceActions.preLoginSuccess;
export const resetState = sliceActions.resetState;
export { sliceActions as self };
